module.exports = __webpack_public_path__ + "img/mobileiot4.5450314f.png";